import { gql } from 'graphql-tag';

/**
 * 获取站点id
 */
export const fetMatomoSiteId = gql`
  query getMatomoSiteId {
    getMatomoSiteId
  }
`;

/**
 * 获取openid
 */
export const openIdDocument = gql`
  query getOpenIdByJsCode($jsCode: String!) {
    getOpenIdByJsCode(jsCode: $jsCode)
  }
`;

/**
 * 上报绑定订单项的来源（订单追踪）
 */
export const fetchBindingOrderLineTrackingDocument = gql`
  mutation bindingOrderLineTracking(
    $orderId: ID!
    $productVariantId: ID!
    $trackingPageType: TrackingPageType!
    $trackingPageId: ID
  ) {
    bindingOrderLineTracking(
      orderId: $orderId
      productVariantId: $productVariantId
      trackingPageType: $trackingPageType
      trackingPageId: $trackingPageId
    )
  }
`;
